import React from "react";

const TranslationsContext = React.createContext();
export default TranslationsContext;
